import { render, staticRenderFns } from "./app.vue?vue&type=template&id=67165268&"
var script = {}
import style0 from "./app.vue?vue&type=style&index=0&id=67165268&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports